<script>
	import { onMount } from 'svelte'
	import { flip } from 'svelte/animate'
	import { cubicInOut } from 'svelte/easing'
	import lozad from 'lozad'

	const { $: jQuery } = window

	let lazyLoadEls = jQuery('.lozad')

	export let services = []
	// console.log('services:', services)

	// $: activePost = services[0]

	// let granite_bg = '/wp-content/uploads/2021/10/granite_bg.png'

	let myinternval

	function nextPost() {
		services = services.slice(1).concat([services[0]])
		clearInterval(myinternval)
	}

	function previousPost() {
		let clonedservicesArray = services.slice(0)
		let firstItem = clonedservicesArray.pop()
		clonedservicesArray.unshift(firstItem)
		services = clonedservicesArray
		clearInterval(myinternval)
	}

	onMount(() => {
		lazyLoadEls = jQuery('.lozad')
		if (lazyLoadEls.length) {
			let observer = lozad()
			observer.observe()
		}
		myinternval = setInterval(() => {
			services = services.slice(1).concat(services[0])
		}, 8000)
	})
</script>

<!-- <div class="granite-bg lozad" data-background-image={granite_bg} /> -->

<div class="outer-service-slider-wrap">
	<div
		class="service-slider-button-wrap"
		data-sal="fade"
		data-sal-duration="500"
		data-sal-delay="150">
		<button
			class="home-service-btn"
			on:click={nextPost}
			aria-label="Next Service">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 572 572"
				xml:space="preserve">
				<path
					d="M297.6 161.9c-4.9-4.9-12.7-4.9-17.6 0-4.9 4.9-4.9 12.7 0 17.6l94.2
					94.2H124c-6.9 0-12.5 5.6-12.5 12.5s5.6 12.5 12.5 12.5h250.1l-94.2
					94.2c-2.3 2.3-3.6 5.5-3.6 8.8 0 3.3 1.3 6.5 3.6 8.8 2.3 2.4 5.5 3.7
					8.9 3.6 3.3 0 6.5-1.3 8.9-3.6L413 294.9c2.3-2.4 3.7-5.5 3.6-8.9
					0-3.3-1.3-6.5-3.6-8.9L297.6 161.9z" />
				<path
					d="M286.2 17.9C177.7 17.9 80 83.2 38.5 183.4-3.1 283.6 19.9 399 96.6
					475.6c104.7 104.7 274.4 104.7 379.1 0 104.7-104.7 104.7-274.4
					0-379.1-50.1-50.4-118.4-78.7-189.5-78.6zm0 511.4C152.1 529.3 43 420.1
					43 286.1S152.1 42.9 286.2 42.9 529.4 152 529.4 286.1 420.2 529.3 286.2
					529.3z" />
			</svg>
		</button>
		<button
			class="home-service-btn"
			on:click={previousPost}
			aria-label="Previous Service">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 572 572"
				xml:space="preserve">
				<path
					d="M297.6 161.9c-4.9-4.9-12.7-4.9-17.6 0-4.9 4.9-4.9 12.7 0 17.6l94.2
					94.2H124c-6.9 0-12.5 5.6-12.5 12.5s5.6 12.5 12.5 12.5h250.1l-94.2
					94.2c-2.3 2.3-3.6 5.5-3.6 8.8 0 3.3 1.3 6.5 3.6 8.8 2.3 2.4 5.5 3.7
					8.9 3.6 3.3 0 6.5-1.3 8.9-3.6L413 294.9c2.3-2.4 3.7-5.5 3.6-8.9
					0-3.3-1.3-6.5-3.6-8.9L297.6 161.9z" />
				<path
					d="M286.2 17.9C177.7 17.9 80 83.2 38.5 183.4-3.1 283.6 19.9 399 96.6
					475.6c104.7 104.7 274.4 104.7 379.1 0 104.7-104.7 104.7-274.4
					0-379.1-50.1-50.4-118.4-78.7-189.5-78.6zm0 511.4C152.1 529.3 43 420.1
					43 286.1S152.1 42.9 286.2 42.9 529.4 152 529.4 286.1 420.2 529.3 286.2
					529.3z" />
			</svg>
		</button>
	</div>
	<div class="service-slider-wrap">
		{#each services as service (service.title)}
			<div
				class="service-item"
				animate:flip={{ duration: 500, easing: cubicInOut }}
				class:active={service == services[0]}>
				<div
					class="service-item-image lozad"
					data-background-image={service.image} />
				<div class="service-item-content">
					<h2>
						{@html service.title}
					</h2>
					{#if service.content}
						{@html service.content}
					{/if}
					<a href={service.link} class="service-item-link">
						LEARN MORE
						<svg
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							width="7px"
							height="12px">
							<path
								fill-rule="evenodd"
								fill="rgb(13, 41, 76)"
								d="M0.627,11.411 L2.551,11.411 L6.815,6.081 L2.551,0.724
								L0.627,0.724 L4.891,6.081 L0.627,11.411 Z" />
						</svg>
						<span class="sr-only">About {service.title}</span>
					</a>
				</div>
			</div>
		{/each}
	</div>
</div>
